import PropTypes from 'prop-types';
import { FunctionField, SelectField, TextField, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { CustomBooleanField } from '@/components/global/fields/CustomBooleanField.jsx';
import { UserMoreActions } from '@/components/users/buttons/UserMoreActions.jsx';
import { UserContractorNamesField } from '@/components/users/fields/UserContractorNamesField.jsx';
import { UserRoleField } from '@/components/users/fields/UserRoleField.jsx';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';
import { languageChoices } from '@/components/global/options/selectOptions.jsx';
import { roleIsService } from '@/constants/Roles.js';

const UserDetailsActions = () => {
    const record = useRecordContext();
    const { permissions } = usePermissions();
    const translate = useTranslate();

    return (
        <UserMoreActions
            permissions={permissions}
            record={record}
            buttonLabel={translate('common.options')}
            className='more-area-in-details'
            color='secondary'
            includeShow={false}
        />
    );
};

export const UserShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const canViewUserContractors = permissions?.isAdmin || permissions?.isBok || permissions?.isClientMaster;

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='user'
            canView={perms => canViewDetails('user', perms)}
            actions={<UserDetailsActions />}
            showChangeHistory
            historyFieldsSource='resources.user.fields'
        >
            <TextField source='firstName' label={translate('resources.user.fields.firstName')} />
            <TextField source='lastName' label={translate('resources.user.fields.lastName')} />
            <TextField source='email' label={translate('resources.user.fields.email')} />
            <TextField source='phone' label={translate('resources.user.fields.phone')} />
            <FunctionField label={translate('resources.user.labels.roleSection')} render={record => <UserRoleField record={record} />} />
            {canViewUserContractors ? <UserContractorNamesField label={translate('common.contractor')} /> : null}
            <FunctionField
                label={translate('resources.user.fields.serviceCompanyId')}
                render={record => (roleIsService(record?.role) ? <TextField source='serviceCompany.name' record={record} /> : null)}
            />
            <SelectField source='language' choices={languageChoices(translate)} label={translate('resources.user.labels.language')} />
            <CustomBooleanField source='isActive' label={translate('resources.user.fields.isActive')} />
        </DetailsShow>
    );
};

UserShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
